export default {"src":"/_next/static/media/download-icon.d009ca1c.svg","height":13,"width":13,"blurWidth":0,"blurHeight":0};